import React from 'react'
import styled from 'styled-components'

const TabTitle = ({ logo, i, tabActive, setTabActive }) => (
  <ListElement className={tabActive === i ? 'active' : ''}>
    <TabTitleButton
      onClick={() => setTabActive(i)}
      className={tabActive === i ? 'active' : ''}
      dangerouslySetInnerHTML={{ __html: logo }}
    />
  </ListElement>
)

const TabTitleButton = styled.button`
  position: relative;
  font-size: 2.2rem;
  font-weight: 300;
  -webkit-font-smoothing: auto;
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  color: #fff;
  transition: opacity 0.3s ease, color 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }

  &:focus {
    outline: 0;
  }

  &.active {
    svg {
      fill: ${props => props.theme.colours.primary};

      ellipse {
        fill: none;
        stroke: ${props => props.theme.colours.primary};
      }
    }

    &:hover {
      opacity: 1;
    }
  }

  svg {
    min-width: 110px;
    min-height: 80px;
    fill: #fff;
    transition: fill 0.3s ease;

    ellipse {
      fill: none;
      stroke: #fff;
    }
  }
`

const ListElement = styled.li`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0 4rem;
  border: 1px solid transparent;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`

export default TabTitle
